module.exports = __webpack_public_path__ + "img/servicePay.0cc59752.png";